/* global SWDLocalise */
import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import history from 'instantsearch.js/es/lib/routers/history';
import { connectMenu } from 'instantsearch.js/es/connectors';
import { pagination } from 'instantsearch.js/es/widgets';
import customHits from './widgets/hits-recipe';

const DOM = {
    searchResults: document.querySelector('.js-recipe-landing-results'),
};

const setup = () => {
    const algoliaClient = algoliasearch(
        SWDLocalise.algoliaAppID,
        SWDLocalise.algoliaAPIKey,
    );

    const searchClient = {
        ...algoliaClient,
    };

    const indexName = `${SWDLocalise.algoliaIndex}recipe`;

    const search = instantsearch({
        searchClient,
        indexName,
        routing: {
            router: history({
                createURL({ qsModule, routeState, location }) {
                    const urlParts = location.href.match(/^(.*?)\/recipes/);
                    const baseUrl = `${urlParts ? urlParts[1] : ''}/`;

                    const productTypePath = routeState.product_type
                        ? `${routeState.product_type}/`
                        : '';

                    const queryParameters = {};

                    // page
                    if (routeState.batch !== 1) {
                        queryParameters.batch = routeState.batch;
                    }

                    const queryString = qsModule.stringify(queryParameters, {
                        addQueryPrefix: true,
                        arrayFormat: 'repeat',
                    });

                    // handle single URL
                    return `${baseUrl}recipes/${productTypePath}${queryString}`;
                },

                parseURL({ qsModule, location }) {
                    const pathnameMatches = location.pathname.match(/recipes\/(.*?)\/?$/);
                    const productType = ((pathnameMatches && pathnameMatches[1]) || '');
                    const {
                        batch,
                    } = qsModule.parse(
                        location.search.slice(1),
                    );

                    return {
                        batch,
                        product_type: productType,
                    };
                },
            }),

            stateMapping: {
                stateToRoute(uiState) {
                    const indexUiState = uiState.wp_spb_recipe || {};
                    return {
                        batch: indexUiState.page,
                        product_type: indexUiState.menu && indexUiState.menu['taxonomies.product_type'],
                    };
                },

                routeToState(routeState) {
                    return {
                        wp_spb_recipe: {
                            page: routeState.batch,
                            menu: {
                                'taxonomies.product_type': routeState.product_type,
                            },
                        },
                    };
                },
            },
        },
        searchFunction(helper) {
            const page = helper.getPage() || 0;

            helper
                .toggleFacetRefinement('visibility', 'visible')
                .setPage(page);

            helper.search();
        },
    });

    const virtualMenuProductType = connectMenu(() => null);
    const virtualMenuVisibility = connectMenu(() => null);

    search.addWidgets([
        virtualMenuProductType({
            attribute: 'taxonomies.product_type',
        }),

        virtualMenuVisibility({
            attribute: 'visibility',
        }),

        customHits({
            container: DOM.searchResults,
        }),

        pagination({
            container: document.querySelector('.js-recipe-landing-pagination'),
            scrollTo: DOM.searchResults,
        }),
    ]);

    search.start();
};

const init = () => {
    if (!DOM.searchResults) return;
    setup();
};

export default init;
